
import Vue from "vue";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { SaleConfig } from "@/models/dossier-configs/sale-config";
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { CustomTranslation } from "@/utils/custom-translation";
import { DossierConfigService } from "@/services/dossier-config-service";
import { TranslateResult } from "vue-i18n";
import AppInputWithTextareaModal from "@/components/common/InputWithTextareaModal.vue";

export default Vue.extend({
	data(){
		return {
			selectedProp: "NR",
			cursorPosition: 0,
			selectedLang: "nl-be",
		};
	},
	props: {
		value: {
			type: Object as ()=>CustomTranslation,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		}
	},
	computed: {
		items():PropSelectGroup{
			return getSaleMapPropSelectGroup();
		},
		addPropButtonEnabled():boolean {
			let text = this.value.Translations[this.selectedLang];
			if(!text){
				return false;
			}
			let part1 = text.substring(0, this.cursorPosition);
			let part2 = text.substring(this.cursorPosition);
			return this.validateString(part1) && this.validateString(part2);
		},
		isValid():boolean {
			return this.validateString(this.value.Translations[this.selectedLang]);
		},
		otherLanguagesValid():boolean {
			let languages = DossierConfigService.getLanguages();
			for (let lang of languages.LanguageNames){
				if (lang == this.selectedLang) {
					continue;
				}
				let val = this.value.getTranslation(lang);
				if (!this.validateString(val)){
					return false;
				}
			}
			return true;
		}
	},
	methods: {
		updateCursorPosition(position:number){
			this.cursorPosition = position;
		},
		addProp(){
			let val = this.value.Translations[this.selectedLang];
			let part1 = val.substring(0, this.cursorPosition);
			let part2 = val.substring(this.cursorPosition);
			this.value.Translations[this.selectedLang] = `${part1}{{ .${this.selectedProp} }}${part2}`;
		},
		validateString(val:string):boolean{
			return SaleConfig.validateSaleImportRowDescriptionTemplate(val);
		}
	},
	components: {
		AppPropSelectAutocomplete,
		AppCustomLanguageSelect,
		AppInputWithTextareaModal
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
